import { DeleteOutlined } from '@ant-design/icons';
import { Button, Form, Input, Modal, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import styled from 'styled-components';
import { FileLabelResponseDto } from '@/shared/api/openapi/openapiSchemas';
import { captureError } from '@/shared/utils/error-reporting';

const LabelTable = styled(Table<FileLabelResponseDto>)`
  .ant-table-cell {
    padding: 8px 16px !important;
  }
`;

interface LabelManagementModalProps {
  open: boolean;
  onClose: () => void;
  labels: FileLabelResponseDto[];
  onCreateLabel: (name: string) => Promise<FileLabelResponseDto>;
  onDeleteLabel: (id: string) => void;
}

export const LabelManagementModal: React.FC<LabelManagementModalProps> = ({
  open,
  onClose,
  labels,
  onCreateLabel,
  onDeleteLabel,
}) => {
  const [form] = Form.useForm();

  const labelColumns: ColumnsType<FileLabelResponseDto> = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 100,
      render: (_, record) => (
        <Button
          type="text"
          icon={<DeleteOutlined />}
          onClick={() => onDeleteLabel(record.id)}
          danger
        />
      ),
    },
  ];

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      await onCreateLabel(values.name);
      form.resetFields();
    } catch (error) {
      captureError(error, {
        module: 'labels',
        action: 'create_label',
      });
    }
  };

  return (
    <Modal
      title="Manage Labels"
      open={open}
      onCancel={onClose}
      footer={null}
      width={500}
    >
      <Form form={form} layout="inline" onFinish={handleSubmit}>
        <Form.Item
          name="name"
          rules={[
            { required: true, message: 'Please input a label name!' },
            { max: 64, message: 'Label name cannot exceed 64 characters' },
          ]}
          style={{ flex: 1, marginRight: 8 }}
        >
          <Input placeholder="Enter label name" maxLength={64} />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Create Label
          </Button>
        </Form.Item>
      </Form>

      <div style={{ marginTop: 16 }}>
        <LabelTable
          columns={labelColumns}
          dataSource={labels}
          rowKey="id"
          pagination={false}
        />
      </div>
    </Modal>
  );
};
